// Dutch translations
export const nl = {
  // Navigation
  'nav.overview': 'Overzicht',
  'nav.dashboard': 'Dashboard',
  'nav.analytics': 'Analyses',
  'nav.reportingDashboard': 'Rapportage-dashboard',
  'nav.sales': 'Verkoop',
  'nav.salesOrders': 'Verkooporders',
  'nav.purchase': 'Inkoop',
  'nav.purchaseOrders': 'Inkooporders',
  'nav.purchaseReview': 'Beoordelings-werkruimte',
  'nav.purchase.sprints': 'Sprints',
  'nav.supplierOnboarding': 'Leveranciers-onboarding',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprints',
  'nav.po.newSprint': 'Sprint aanmaken',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Weekplanning',
  'nav.scout.tagesplanung': 'Dagplanning',
  'nav.scout.prequal': 'PreQual Bellen',
  'nav.scout.missionen': 'Missies',
  'nav.scout.missionControl': 'Missieleiding',
  'nav.scout.unternehmenssuche': 'Bedrijfszoeker',
  'nav.scout.preferences': 'Instellingen',
  'nav.scout.hilfe': 'Hulp',
  'nav.scout.scorecard': 'Scorecard',
  'nav.poSprints': 'PO/Sprints',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Supportvisualisatie',
  'nav.navigationTiles': 'Navigatietegels',
  'nav.styleGuide': 'Stijlgids',
  'nav.inventory': 'Voorraad',
  'nav.items': 'Artikelen',
  'nav.warehouse': 'Magazijn',
  'nav.picking': 'Orderpicken',
  'nav.asn': 'ASN',
  'nav.returns': 'Retourzendingen',
  'nav.accounting': 'Boekhouding',
  'nav.accountsReceivable': 'Debiteuren',
  'nav.crm': 'CRM',
  'nav.leads': 'Leads',
  'nav.contacts': 'Contacten',
  'nav.ai': 'AI',
  'nav.commandCenter': 'Commandocentrum',
  'nav.workflows': 'Workflows',
  'nav.workflowManagement': 'Workflowbeheer',
  'nav.projectManagement': 'Projectbeheer',
  'nav.support': 'Ondersteuning',
  'nav.tickets': 'Tickets',
  'nav.pivotTable': 'Draaitabel',
  'nav.learning': 'Leren',
  'nav.curriculumPlanning': 'Leerplanplanning',
  'nav.learnerDashboard': 'Leerlingdashboard',
  'nav.accessibleLearnerDashboard': 'Toegankelijk leerlingdashboard',
  'nav.settings': 'Instellingen',
  'nav.general': 'Algemeen',
  'nav.company': 'Bedrijf',
  'nav.addressManagement': 'Adresbeheer',
  'nav.usersRoles': 'Gebruikers & Rollen',
  'nav.auditLog': 'Auditlog',
  'nav.integrations': 'Integraties',
  'nav.appOverview': 'App-overzicht',
  'nav.appOverviewDescription': 'Klik op een app om te navigeren, of sleep tegels om ze te herordenen',
  'header.help': 'Hulp',
  'header.account': 'Account',
  'header.portalName': 'CLANDA Portaal',
  'header.preferences': 'Voorkeuren',
  'header.language': 'Taal',

  // Help page

  // Privacy page

  // Form

  // Placeholders
  
  // Status
  
  // Actions
  'action.delete': 'Verwijderen',
  
  // Messages
  'message.success': 'Gelukt',
  'message.error': 'Fout',
  
  // Common
  'common.yes': 'Ja',
  'common.no': 'Nee',
  'common.cancel': 'Annuleren',
  'common.confirm': 'Bevestigen',
  'common.save': 'Opslaan',
  'common.saveChanges': 'Wijzigingen opslaan',
  'common.close': 'Sluiten',
  'common.reset': 'Opnieuw instellen',
  'common.back': 'Terug',
  'common.loading': 'Laden...',
  'common.search': 'Zoeken',
  'common.search.placeholder': 'Zoeken...',
  'common.filter': 'Filter',
  'common.sort': 'Sorteren',
  'common.add': 'Toevoegen',
  'common.delete': 'Verwijderen',
  'common.edit': 'Bewerken',
  'common.error': 'Fout',
  'common.remove': 'Verwijderen',
  'common.minutesShort': '{{value}} min',
  'common.na': 'N.v.t.',
  'common.days': 'dagen',
  'common.status.active': 'actief',
  'common.status.paused': 'gepauzeerd',
  'common.status.stopped': 'gestopt',
  'common.status.pending': 'in afwachting',
  'common.status.completed': 'afgerond',
  'common.status.planned': 'Gepland',
  'common.status.inProgress': 'In uitvoering',
  'common.status.done': 'Gereed',
  'common.apply': 'Toepassen',
  'common.actions.filter': 'Filter',
  'common.actions.export': 'Exporteren',
  'common.actions.search': 'Zoeken',
  'common.dialog.defaultTitle': 'Dialoog',
  'common.all': 'Alle',
  'common.total': 'Totaal',
  'common.pending': 'In afwachting',
  'common.assigned': 'Toegewezen',
  'common.inProgress': 'In uitvoering',
  'common.completed': 'Afgerond',
  'common.cancelled': 'Geannuleerd',
  'common.approved': 'Goedgekeurd',
  'common.rejected': 'Afgewezen',
  'common.processing': 'Verwerking',
  'common.overdue': 'Achterstallig',
  'common.partial': 'Gedeeltelijk',
  'common.highPriority': 'Hoge prioriteit',
  'common.tableView': 'Tabelweergave',
  'common.cardView': 'Kaartweergave',
  'common.switchToTable': 'Naar tabelweergave wisselen',
  'common.switchToCard': 'Naar kaartweergave wisselen',
  'common.openMenu': 'Menu openen',
  'common.details': 'Details',
  'common.overview': 'Overzicht',
  'common.new': 'Nieuw',
  'common.draft': 'Concept',
  'common.shipped': 'Verzonden',
  'common.delivered': 'Geleverd',
  'common.received': 'Ontvangen',
  'common.inTransit': 'Onderweg',
  'common.itemsPicked': 'Artikelen gepickt',
  'common.totalRefund': 'Totale terugbetaling',
  'common.totalPrice': 'Totaalprijs',
  'common.orderSummary': 'Besteloverzicht',
  'common.subtotal': 'Subtotaal:',
  'common.tax': 'BTW:',
  'common.discount': 'Korting:',
  'common.totalColon': 'Totaal:',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Vandaag',
  'dateRange.yesterday': 'Gisteren',
  'dateRange.last7Days': 'Laatste 7 dagen',
  'dateRange.last14Days': 'Laatste 14 dagen',
  'dateRange.last30Days': 'Laatste 30 dagen',
  'dateRange.thisMonth': 'Deze maand',
  'dateRange.custom': 'Aangepast',

  // Dashboard
  'widget.vsLastPeriod': 'vs vorige periode',
  'table.showing': 'Toont',
  'table.of': 'van',
  'table.page': 'Pagina',
  'table.previous': 'Vorige',
  'table.next': 'Volgende',
  'table.filterGroups': 'Filtergroepen',
  'table.addFilterGroup': 'Filtergroep toevoegen',
  'table.filterGroup': 'Filtergroep',
  'table.addCondition': 'Voorwaarde toevoegen',
  'table.operator': 'Operator',
  'table.field': 'Veld',
  'table.noFilterGroups': 'Geen filtergroepen.',
  'filter.operator.equals': 'is gelijk aan',
  'filter.operator.not_equals': 'is niet gelijk aan',
  'filter.operator.contains': 'bevat',
  'filter.operator.not_contains': 'bevat niet',
  'filter.operator.starts_with': 'begint met',
  'filter.operator.ends_with': 'eindigt met',
  'filter.operator.gt': 'groter dan',
  'filter.operator.lt': 'kleiner dan',
  'filter.operator.gte': 'minstens',
  'filter.operator.lte': 'hoogstens',
  'filter.operator.between': 'tussen',
  'filter.operator.in': 'is een van',
  'filter.operator.not_in': 'is geen van',
  'filter.operator.is_set': 'is ingesteld',
  'filter.operator.is_not_set': 'is niet ingesteld',
  'filter.placeholder.value': 'Waarde',
  'filter.placeholder.min': 'Min',
  'filter.placeholder.max': 'Max',
  'filter.placeholder.select': 'Selecteren…',
  'filter.placeholder.selectMultiple': 'Waarden selecteren…',
  'filter.logic.and': 'EN',
  'filter.logic.or': 'OF',

  // Documents
  
  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Accountinstellingen',

  // Consent
  'consent.title': 'Toestemming',
  'consent.label': 'Ik ga akkoord met de voorwaarden en het bestelbeleid',
  'consent.description': 'Ik heb de voorwaarden gelezen en accepteer deze.',
  'consent.required': 'Ga akkoord met de voorwaarden.',
  'consent.link.terms': 'Voorwaarden',

  // Contacts
  'contacts.title': 'Contacten',
  'contacts.role': 'Rol',
  'contacts.role.admin': 'Beheerder',
  'contacts.role.billing': 'Facturering',
  'contacts.role.technical': 'Technisch',
  'contacts.role.other': 'Overig',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Authenticatie',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page


  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': 'Hallo {{name}}!',
  'learning.feed.levelInfo': 'Niveau {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Offline',
  'learning.feed.streakLabel': 'Dagenreeks',
  'learning.feed.dailyGoal': 'Dagelijks doel',
  'learning.feed.recommendedLessons': 'Aanbevolen lessen',
  'learning.feed.priority.high': 'Hoog',
  'learning.feed.priority.medium': 'Gemiddeld',
  'learning.feed.priority.low': 'Laag',
  'learning.feed.difficulty.easy': 'Makkelijk',
  'learning.feed.difficulty.medium': 'Gemiddeld',
  'learning.feed.difficulty.hard': 'Moeilijk',
  'learning.feed.aiRecommendation': 'AI-aanbeveling',
  'learning.feed.actions.start': 'Starten',
  'learning.feed.actions.skip': 'Overslaan',
  'learning.feed.actions.reload': 'Herladen',
  'learning.feed.empty.title': 'Alle lessen voltooid!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'Je hebt alle beschikbare lessen voor vandaag afgerond. Kom morgen terug!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Vraag {{current}} van {{total}}',
  'learning.quiz.options.true': 'Waar',
  'learning.quiz.options.false': 'Onwaar',
  'learning.quiz.actions.next': 'Volgende',
  'learning.quiz.actions.finish': 'Afronden',
  'learning.quiz.actions.retry': 'Opnieuw proberen',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Quiz geslaagd!',
  'learning.quiz.result.failedTitle': 'Quiz niet geslaagd',
  'learning.quiz.result.scoreSummary': '{{correct}} van {{total}} correct',
  'learning.quiz.result.xpEarned': '+{{xp}} XP verdiend',
  'learning.quiz.result.answersHeading': 'Gedetailleerde antwoorden',
  'learning.quiz.result.questionLabel': 'Vraag {{index}}',
  'learning.quiz.result.yourAnswer': 'Jouw antwoord',
  'learning.quiz.result.correctAnswer': 'Juiste antwoord',
  'learning.lessonCard.difficulty.easy': 'Makkelijk',
  'learning.lessonCard.difficulty.medium': 'Gemiddeld',
  'learning.lessonCard.difficulty.hard': 'Moeilijk',
  'learning.lessonCard.status.completed': 'Voltooid',
  'learning.lessonCard.reward': 'Beloning',
  'learning.lessonCard.progress': 'Voortgang',
  'learning.lessonCard.selectFormat': 'Formaat kiezen',
  'learning.lessonCard.prerequisites': 'Vereisten',
  'learning.lessonCard.actions.start': 'Starten',
  'learning.lessonCard.actions.repeat': 'Herhalen',
  'learning.lessonCard.actions.pause': 'Pauzeren',
  'learning.lessonCard.actions.complete': 'Voltooien',
  'learning.lessonCard.actions.bookmark': 'Bladwijzer',
  'learning.lessonCard.actions.unbookmark': 'Bladwijzer verwijderen',
  'learning.lessonCard.actions.collapse': 'Inklappen',
  'learning.lessonCard.actions.expand': 'Uitklappen',
  'learning.lessonCard.goalLabel': 'Doel',
  'learning.lessonCard.formats.video': 'Video bekijken',
  'learning.lessonCard.formats.text': 'Tekst lezen',
  'learning.lessonCard.formats.audio': 'Audio beluisteren',
  'learning.lessonCard.formats.cheatSheet': 'Spiekbriefje',
  'learning.lessonCard.formatUnknown': 'Onbekend',
  'learning.accessible.title': 'Leerdashboard',
  'learning.accessible.welcome': 'Welkom terug, {{name}}',
  'learning.accessible.voice.start': 'Spraak',
  'learning.accessible.voice.stop': 'Spraakbesturing stoppen',
  'learning.accessible.voice.listening': 'Luistert...',
  'learning.accessible.level': 'Niveau',
  'learning.accessible.xpToNext': '{{value}} XP tot volgend niveau',
  'learning.accessible.streak': 'Reeks',
  'learning.accessible.days': '{{value}} dagen',
  'learning.accessible.keepItUp': 'Ga zo door!',
  'learning.accessible.badges': 'Badges',
  'learning.accessible.achievementsEarned': 'Behaalde prestaties',
  'learning.accessible.tabs.overview': 'Overzicht',
  'learning.accessible.tabs.lessons': 'Lessen',
  'learning.accessible.tabs.progress': 'Voortgang',
  'learning.accessible.tabs.achievements': 'Prestaties',
  'learning.accessible.recentActivity': 'Recente activiteit',
  'learning.accessible.noRecentActivity': 'Geen recente activiteit',
  'learning.accessible.start': 'Starten',
  'learning.accessible.learningProgress': 'Leervoortgang',
  'learning.accessible.overallProgress': 'Totale voortgang',
  'learning.accessible.achievements': 'Prestaties',
  'learning.accessible.startingLesson': 'Les {{id}} starten',
  'learning.accessible.difficulty.beginner': 'Beginner',
  'learning.accessible.difficulty.intermediate': 'Gemiddeld',
  'learning.accessible.difficulty.advanced': 'Gevorderd',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Reeksvoortgang',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Les',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Reeks',
  'gamification.xpToast.source.badge': 'Badge',
  'gamification.xpToast.source.bonus': 'Bonus',
  'gamification.xpToast.levelUp.title': 'Niveau omhoog!',
  'gamification.xpToast.levelUp.description': 'Je hebt niveau {{level}} bereikt!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP verdiend',
  'gamification.xpToast.button.continue': 'Doorgaan',
  'gamification.xpToast.streakMilestone.title': 'Reeksmijlpaal!',
  'gamification.xpToast.streakMilestone.description': '{{count}}-daagse reeks behaald!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP bonus verdiend',
  'gamification.close': 'Sluiten',

  // Kennisbank
  'knowledgeBase.back': 'Terug',
  'knowledgeBase.article.view': 'Bekijken',
  'knowledgeBase.article.views': '{{count}} weergaven',
  'knowledgeBase.article.helpful': '{{count}} behulpzaam',
  'knowledgeBase.article.notHelpful': '{{count}} niet behulpzaam',
  'knowledgeBase.article.byAuthor': 'Door {{author}}',
  'knowledgeBase.header.title': 'Kennisbank',
  'knowledgeBase.header.subtitle': 'Vind antwoorden op uw vragen',
  'knowledgeBase.actions.filter': 'Filter',
  'knowledgeBase.actions.sort': 'Sorteren',
  'knowledgeBase.search.placeholder': 'Zoeken in de kennisbank...',
  'knowledgeBase.tabs.all': 'Alle',
  'knowledgeBase.stats.popular': 'Populairste artikelen',
  'knowledgeBase.stats.viewsCount': '{{count}} weergaven',
  'knowledgeBase.stats.helpful': 'Meest behulpzame artikelen',
  'knowledgeBase.stats.ratingsCount': '{{count}} beoordelingen',
  'knowledgeBase.stats.total': 'Totaal artikelen',
  'knowledgeBase.stats.totalCount': '{{count}} artikelen',
  'knowledgeBase.empty.title': 'Geen artikelen gevonden',
  'knowledgeBase.empty.searching': 'Probeer andere zoektermen of bekijk de categorieën.',
  'knowledgeBase.empty.default': 'Er zijn nog geen artikelen beschikbaar in deze categorie.',
  'knowledgeBase.difficulty.beginner': 'Beginner',
  'knowledgeBase.difficulty.intermediate': 'Gevorderd',
  'knowledgeBase.difficulty.advanced': 'Expert',
  'knowledgeBase.categories.odoo-basics': 'Odoo-basis',
  'knowledgeBase.categories.crm': 'CRM & Verkoop',
  'knowledgeBase.categories.inventory': 'Voorraad & Inkoop',
  'knowledgeBase.categories.accounting': 'Boekhouding',
  'knowledgeBase.categories.projects': 'Projectbeheer',
  'knowledgeBase.categories.troubleshooting': 'Probleemoplossing',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Video',
  'curriculum.videoDescription': 'Schermopname of praktijkvideo',
  'curriculum.cheatSheet': 'Spiekbriefje',
  'curriculum.cheatSheetDescription': 'Drukklaar, QR-codes',
  'curriculum.test': 'Test/Quiz',
  'curriculum.testDescription': 'Odoo-enquête, 10 vragen, 80%',
  'curriculum.checklist': 'Checklist',
  'curriculum.checklistDescription': 'Odoo-taken, klikbaar',
  'curriculum.textLesson': 'Tekst/Les',
  'curriculum.textLessonDescription': 'Odoo-cursusles',
  'curriculum.roleplay': 'Rollenspel',
  'curriculum.roleplayDescription': 'Live met mentor/Benno',
  'curriculum.practice': 'Praktijkopdracht',
  'curriculum.practiceDescription': 'Bij de klant uitvoeren',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'Weekoverzicht',
  'scout.wochenplanung.previousWeek': 'Vorige week',
  'scout.wochenplanung.nextWeek': 'Volgende week',
  'scout.wochenplanung.toast.appointmentAdded': 'Afspraak toegevoegd',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Afspraak bijgewerkt',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Afspraak verwijderd',
  'scout.wochenplanung.toast.slotUpdated': 'Slot bijgewerkt',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Missie opgelost of slot verwijderd.',

  // Planning legend
  'scout.wochenplanung.legend.completed': 'voltooid',
  'scout.wochenplanung.legend.planned': 'gepland',
  'scout.wochenplanung.legend.partial': 'gedeeltelijk gepland',
  'scout.wochenplanung.legend.unplanned': 'te plannen',
  'scout.wochenplanung.legend.holiday': 'Feestdag / Vakantie',

  // Missions section

  // Map section
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Afspraak verwijderen',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Weet u zeker dat u deze afspraak wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Afspraak bewerken',
  'scout.wochenplanung.dialog.editAppointment.description': 'Wilt u de wijzigingen op deze afspraak toepassen?',
  'scout.wochenplanung.employee': 'Medewerker',
  'scout.wochenplanung.selectEmployee': 'Medewerker selecteren',
  'scout.wochenplanung.allEmployees': 'Alle medewerkers',
  'scout.wochenplanung.error.loading': 'Fout bij het laden van de weekplanning',
  'scout.wochenplanung.error.retry': 'Opnieuw proberen',

  // SCOUT - Mission list empty state & actions
  'scout.missionControl.tabs.team': 'Teamoverzicht',
  'scout.missionControl.teamMembers': 'Teamleden',
  'scout.missionControl.table.employee': 'Medewerker',
  'scout.missionControl.table.team': 'Team',
  'scout.missionControl.table.plzAreas': 'Postcodegebieden',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': 'Fout bij laden van bestaande klanten',
  'scout.missionen.bestandskunden.empty': 'Geen bestaande klanten gevonden',
  'scout.missionen.bestandskunden.search': 'Bestaande klanten zoeken...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} van {{total}} bestaande klanten',
  'scout.missionen.wunschliste.industriesTitle': 'Voorkeursbranches',
  'scout.missionen.wunschliste.productsTitle': 'Voorkeursproducten',
  'scout.missionen.wunschliste.plzTitle': 'Voorkeurs postcodegebieden',
  'scout.missionen.wunschliste.saveButton': 'Opslaan',
  'scout.missionen.wunschliste.saved': 'Opgeslagen',
  'scout.missionen.wunschliste.savedDesc': 'Uw voorkeuren zijn opgeslagen.',
  'scout.missionen.wunschliste.saveError': 'Fout',
  'scout.missionen.wunschliste.saveErrorDesc': 'Voorkeuren konden niet worden opgeslagen.',
  'scout.missionen.wunschliste.loadError': 'Fout bij laden van voorkeuren',
  'scout.tagesplanung.title': 'Dagplanning',
  'scout.tagesplanung.addressUnknown': 'Adres onbekend',
  'scout.tagesplanung.routeMapLabel': 'Routekaart',
  'scout.tagesplanung.routePlanning': 'Routeplanning',
  'scout.tagesplanung.traffic': 'Verkeer',
  'scout.tagesplanung.deferNotPossible': 'Uitstellen niet mogelijk',
  'scout.tagesplanung.deferMaxReached': 'Maximaal aantal uitstellingen voor vandaag bereikt (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Deze lead is vandaag al uitgesteld.',
  'scout.tagesplanung.dayCannotClose': 'Dag kan niet worden afgesloten',
  'scout.tagesplanung.outstandingReports': 'Er zijn nog {{count}} openstaande bezoekrapporten. Vul deze eerst in voordat u de dag afsluit.',
  'scout.tagesplanung.andMore': '... en {{count}} meer',
  'scout.tagesplanung.tabs.planning': 'Dagplan',
  'scout.tagesplanung.tasks.tabLabel': 'Taken',
  'scout.tagesplanung.tasks.empty': 'Geen taken',
  'scout.tagesplanung.tasks.loading': 'Taken laden',
  'scout.tagesplanung.tasks.error': 'Taken konden niet worden geladen',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Status',
  'scout.tagesplanung.tasks.filterStatusTodo': 'Te doen',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'Bezig',
  'scout.tagesplanung.tasks.filterStatusDone': 'Afgerond',
  'scout.tagesplanung.tasks.priorityLabel': 'Prioriteit',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Deadline',
  'scout.tagesplanung.tasks.dueNone': 'Geen deadline',
  'scout.lead.neukunde': 'Nieuwe klant — Nichemiddel als opener',
  'scout.lead.bestandskunde': 'Bestaande klant',
  'scout.metrics.besuche': 'Bezoeken',
  'scout.metrics.demos': 'Demo\'s',
  'scout.metrics.auftraege': 'Orders',
  'scout.metrics.umsatz': 'Omzet',
  'scout.metrics.demoRate': 'Demo-percentage',
  'scout.composition.title': 'Missie-samenstelling',
  'scout.composition.minBestandskunden': 'Min. bestaande klanten',
  'scout.composition.minQualifiziert': 'Min. gekwalificeerde leads',
  'scout.composition.maxKaltbesuche': 'Max. koude bezoeken',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Afspraak toevoegen',
  'scout.dailyPlanning.appointments': 'Afspraken',
  'scout.dailyPlanning.noAppointmentsPlanned': 'Geen afspraken gepland voor deze dag',
  'scout.dailyPlanning.leadsByPriority': 'Leads (op prioriteit)',
  'scout.dailyPlanning.noLeadsPlanned': 'Geen leads gepland voor deze dag',
  'scout.dailyPlanning.skipLead': 'Lead overslaan',
  'scout.dailyPlanning.skipLeadConfirmation': 'Wilt u deze lead echt overslaan? Hij wordt naar de volgende dag verplaatst.',
  'scout.dailyPlanning.skip': 'Overslaan',
  'scout.dailyPlanning.removeLead': 'Lead verwijderen',
  'scout.dailyPlanning.removeLeadConfirmation': 'Wilt u deze lead echt verwijderen? Hij wordt volledig uit de rotatie gehaald.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Selecteer een missie om de leads te bekijken',
  'scout.dailyPlanning.selectDate': 'Datum selecteren',
  'scout.dailyPlanning.nextDay': 'Volgende dag',
  'scout.dailyPlanning.closeDay': 'Dag afsluiten',
  'scout.dailyPlanning.reopenDay': 'Dag heropenen',
  'scout.dailyPlanning.noAcceptedLeads': 'Geen geaccepteerde leads voor deze dag.',
  'scout.dailyPlanning.statusSkipped': 'Overgeslagen',
  'scout.dailyPlanning.selectAll': 'Alles selecteren',
  'scout.dailyPlanning.selectAllLeads': 'Alle leads selecteren',
  'scout.dailyPlanning.noSuggestions': 'Geen suggesties.',
  'scout.dailyPlanning.previousDay': 'Vorige dag',
  'scout.dailyPlanning.calendarWeek': 'Kalenderweek {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Bezoek',
  'scout.dailyPlanning.details': 'Details',
  'scout.dailyPlanning.missionsLoading': 'Missies worden geladen…',
  'scout.dailyPlanning.leadsLoading': 'Leads worden geladen…',
  'scout.dailyPlanning.noLeadsFound': 'Geen leads gevonden',
  'scout.dailyPlanning.moreLeads': 'meer',
  'scout.dailyPlanning.dailyList': 'Daglijst',
  'scout.dailyPlanning.unknown': 'Onbekend',
  'scout.dailyPlanning.suggestedLeads': 'Voorgestelde leads',
  'scout.dailyPlanning.error': 'Fout: {{error}}',
  'scout.dailyPlanning.help': 'Hulp',
  'scout.dailyPlanning.bulkActions': 'Bulkacties',
  'scout.dailyPlanning.actionsCount': 'Acties ({{count}})',
  'scout.dailyPlanning.accept': 'Accepteren',
  'scout.dailyPlanning.reject': 'Afwijzen',
  'scout.dailyPlanning.selectLead': 'Lead {{name}} selecteren',
  'scout.dailyPlanning.openLeadDetails': 'Details van {{name}} openen',
  'scout.dailyPlanning.score': 'Score: {{score}}',
  'scout.dailyPlanning.loading': 'Dagplanning wordt geladen',
  // Scout weekly planning
  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Metric voor heatmap selecteren',
  'scout.scorecard.orders': 'Orders',
  'scout.scorecard.annualTargetOrders': 'Jaardoel orders',
  'scout.scorecard.comingSoon': 'Binnenkort beschikbaar',
  'scout.scorecard.kpiOverview': 'KPI-overzicht, activiteiten en topbranches',
  'scout.scorecard.activityByDay': 'Activiteit per dag',
  'scout.scorecard.title': 'Scorecard',
  'scout.scorecard.period.tag': 'Dag',
  'scout.scorecard.period.woche': 'Week',
  'scout.scorecard.period.monat': 'Maand',
  'scout.scorecard.period.jahr': 'Jaar',
  'scout.scorecard.kpiTilesHeading': 'KPI-tegels',
  'scout.scorecard.topBranchenProdukteHeading': 'Top branches en top producten',
  'scout.scorecard.soll': 'Doel',
  'scout.scorecard.forecast': 'Prognose',
  'scout.scorecard.gapToGo': 'Te gaan',
  'scout.scorecard.csvExport': 'CSV-export',
  'scout.scorecard.pdfExport': 'PDF-export',
  'scout.scorecard.table.date': 'Datum',
  'scout.scorecard.table.visits': 'Bezoeken',
  'scout.scorecard.table.demos': 'Demo\'s',
  'scout.scorecard.table.orders': 'Orders',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Netto-omzet',
  'scout.scorecard.table.total': 'Totaal',
  'scout.scorecard.topBranchen': 'Top branches',
  'scout.scorecard.topProdukte': 'Top producten',
  'scout.scorecard.table.industry': 'Branch',
  'scout.scorecard.table.quantity': 'Aantal (verpakking)',
  'scout.scorecard.table.revenue': 'Omzet (€)',
  'scout.scorecard.table.product': 'Product',
  'scout.scorecard.table.salesVolume': 'Verkoopvolume',
  'scout.scorecard.table.customers': 'Klanten',
  'scout.scorecard.kpi.visits': 'Bezoeken',
  'scout.scorecard.kpi.demos': 'Demo\'s',
  'scout.scorecard.kpi.orders': 'Orders',
  'scout.scorecard.kpi.netRevenue': 'Netto-omzet',
  'scout.scorecard.kpi.gebinde60l': 'Verpakking 60L',
  'scout.scorecard.kpi.gebinde25l': 'Verpakking 25L',
  'scout.scorecard.kpi.gebinde10l': 'Verpakking 10L',
  'scout.scorecard.emptyTitle': 'Geen gegevens',
  'scout.scorecard.emptyDescription': 'Geen KPI-gegevens voor de geselecteerde periode.',
  'scout.scorecard.missionPerformanceTitle': 'Missieprestaties',
  'scout.scorecard.missionMissionsCompleted': 'Voltooide missies',
  'scout.scorecard.missionConversionRate': 'Conversiepercentage',
  'scout.scorecard.missionTerritoryCoverage': 'Gebiedsdekking',
  'scout.scorecard.viewMissionDetails': 'Details bekijken',
  'scout.scorecard.adjustTargets': 'Doelen aanpassen',
  'scout.scorecard.annualTarget': 'Jaardoel',
  'scout.scorecard.annualTargetVisits': 'Jaardoel bezoeken',
  'scout.scorecard.annualTargetDemos': 'Jaardoel demo\'s',
  'scout.scorecard.annualTargetNetRevenue': 'Netto-omzet (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Jaardoel netto-omzet in euro',
  'scout.scorecard.monthlyOverrides': 'Maandelijkse afwijkingen',
  'scout.scorecard.table.month': 'Maand',
  'scout.scorecard.table.reason': 'Reden',
  'scout.scorecard.derivedTargets': 'Afgeleide doelen',
  'scout.scorecard.dailyTargetLabel': 'Dagdoel: {{count}} bezoeken',
  'scout.scorecard.weeklyTargetLabel': 'Weekdoel: {{count}} bezoeken',
  'scout.scorecard.save': 'Opslaan',
  'scout.scorecard.heatmap.visits': 'Bezoeken',
  'scout.scorecard.heatmap.demos': 'Demo\'s',
  'scout.scorecard.heatmap.revenue': 'Omzet',
  'scout.scorecard.heatmap.low': 'Weinig',
  'scout.scorecard.heatmap.high': 'Veel',
  'scout.scorecard.heatmap.scaleA11y': 'Kleurschaal van weinig tot veel',
  'scout.scorecard.heatmap.loading': 'Kaart wordt geladen…',
  // Scout mission control
  'scout.missionControl.teamOverview': 'Uw team en hun postcodegebieden',
  'scout.missionControl.jokerLimitPerDay': 'Jokerlimiet / dag',
  'scout.missionControl.jokerLimitUpdated': 'Jokerlimiet is bijgewerkt.',
  'scout.missionControl.jokerLimitSaveFailed': 'Jokerlimiet kon niet worden opgeslagen.',
  'scout.missionControl.selectTeam': 'Team selecteren',
  'scout.missionControl.none': 'Geen',
  'scout.missionControl.addPlzAreaFor': 'Postcodegebied toevoegen voor',
  'scout.missionControl.addPlzArea': 'Postcodegebied toevoegen',
  'scout.missionControl.noTeamMembersFound': 'Geen teamleden gevonden.',
  'scout.missionControl.orders': 'Orders',
  'scout.missionControl.resetSettings': 'Instellingen resetten',
  'scout.missionControl.saveSettings': 'Instellingen opslaan',
  'scout.missionControl.territorySaturation': 'Gebiedsverzadiging (postcode)',
  'scout.missionControl.day': 'Dag',
  'scout.missionControl.selectDay': 'Dag selecteren',
  'scout.missionControl.week': 'Week',
  'scout.missionControl.selectWeek': 'Week selecteren',
  'scout.missionControl.month': 'Maand',
  'scout.missionControl.selectMonth': 'Maand selecteren',
  'scout.missionControl.planFulfillment': 'Planuitvoering',
  'scout.missionControl.plzPrefixPlaceholder': 'Postcodevoorvoegsel (bijv. 70)',
  'scout.missionControl.plzPrefix': 'Postcodevoorvoegsel',
  'scout.missionControl.addPlzToWhitelist': 'Postcodevoorvoegsel aan whitelist toevoegen',
  'scout.missionControl.addPlzToGreylist': 'Postcodevoorvoegsel aan grijze lijst toevoegen',
  'scout.missionControl.addPlzToYellowlist': 'Postcodevoorvoegsel aan gele lijst toevoegen',
  'scout.missionControl.addNewTeamMember': 'Nieuw teamlid toevoegen',
  'scout.missionControl.lastModified': 'Laatst gewijzigd',
  'scout.missionControl.outsideAreaRules': 'Regels buiten gebied',
  'scout.missionControl.outsidePlzPolicy': 'Beleid voor postcodes buiten de lijsten',
  'scout.missionControl.enableOutsideWarning': 'Waarschuwing voor postcode buiten gebied inschakelen',
  'scout.missionControl.requireOutsideApproval': 'Goedkeuring vereist voor postcode buiten gebied',
  'scout.missionControl.rejectOutsidePlz': 'Postcode buiten gebied afwijzen',
  'scout.missionControl.checkPlz': 'Postcode of voorvoegsel controleren',
  'scout.missionControl.check': 'Controleren',
  'scout.missionControl.error': 'Fout',
  'scout.missionControl.success': 'Succes',
  'scout.missionControl.userProfileNotFound': 'Gebruikersprofiel niet gevonden',
  'scout.missionControl.plzAreasUpdated': 'Postcodegebieden bijgewerkt',
  'scout.missionControl.plzAreasSaveFailed': 'Postcodegebieden konden niet worden opgeslagen',

  // Mission Control → Config → KPI Target Configuration (MC-004)

  // Scout Mission Control — Rep Config (T13)
  'scout.missionControl.repConfig.title': 'Vertegenwoordigerconfiguratie',
  'scout.missionControl.repConfig.repName': 'Naam / e-mail',
  'scout.missionControl.repConfig.industries': 'Branches',
  'scout.missionControl.repConfig.products': 'Producten',
  'scout.missionControl.repConfig.plz': 'Postcode',
  'scout.missionControl.repConfig.loadError': 'Vertegenwoordigerconfiguratie kon niet worden geladen',
  'scout.missionControl.repConfig.saveError': 'Opslaan mislukt',
  'scout.missionControl.repConfig.savedTitle': 'Opgeslagen',
  'scout.missionControl.repConfig.savedDesc': 'Vertegenwoordigerconfiguratie is bijgewerkt',

  // Scout Mission Control — Joker Limit (T16)
  'scout.missionControl.jokerConfig.title': 'Jokerlimiet per dag',
  'scout.missionControl.jokerConfig.description': 'Maximaal aantal joker-inzetten per vertegenwoordiger per dag.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Max. per dag',
  'scout.missionControl.jokerConfig.loadError': 'Jokerconfiguratie kon niet worden geladen',
  'scout.missionControl.jokerConfig.saveError': 'Opslaan mislukt',
  'scout.missionControl.jokerConfig.savedTitle': 'Opgeslagen',
  'scout.missionControl.jokerConfig.savedDesc': 'Jokerlimiet is bijgewerkt',

  // Scout session (NAV-005)

  // Scout Mission Control — territories (MC-001, MC-002)

  // Scout Mission Control — diagnostics (MC-006)
  'scout.missionControl.diagnostics.demoRate': 'Demo-percentage',
  'scout.missionControl.diagnostics.visitDepth': 'Bezoekdiepte',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': 'Alle zoekresultaten selecteren',
  'scout.unternehmenssuche.openingHours': 'OPENINGSTIJDEN',
  'scout.unternehmenssuche.temporarilyClosed': 'Tijdelijk gesloten',
  'scout.unternehmenssuche.startSearch': 'Zoeken starten',
  'scout.unternehmenssuche.searchRunning': 'Zoeken wordt uitgevoerd...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Pas de zoekcriteria aan of probeer het opnieuw.',
  'scout.unternehmenssuche.selectCompanyType': 'Bedrijfstype selecteren',
  'scout.unternehmenssuche.openingHoursTime': 'Openingstijd',
  'scout.unternehmenssuche.noTimeNeeded': 'Geen tijd nodig',
  'scout.unternehmenssuche.addConditions': 'Voeg voorwaarden toe om uw zoekopdracht te verfijnen',
  'scout.unternehmenssuche.addCondition': 'Voorwaarde toevoegen',
  'scout.unternehmenssuche.addGroup': 'Groep toevoegen',
  'scout.unternehmenssuche.savedSearchName': 'Naam opgeslagen zoekopdracht',
  'scout.unternehmenssuche.saveCurrentSearch': 'Huidige zoekopdracht opslaan',
  'scout.unternehmenssuche.savedSearches': 'Opgeslagen zoekopdrachten',
  'scout.unternehmenssuche.noSavedSearches': 'Geen opgeslagen zoekopdrachten.',
  'scout.unternehmenssuche.keywordPlaceholder': 'bijv. Restaurant, Bar, Bakkerij',
  'scout.unternehmenssuche.addWaypoint': 'Tussenstop toevoegen',
  'scout.unternehmenssuche.locationPlaceholder': 'bijv. München Marienplatz',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Extra filters in- of uitschakelen',
  'scout.unternehmenssuche.additionalFilters': 'Extra filters',
  'scout.unternehmenssuche.saveSearchAsFile': 'Zoekopdracht als bestand opslaan',
  'scout.unternehmenssuche.loadSearchFromFile': 'Zoekopdracht uit bestand laden',
  'scout.unternehmenssuche.checkSearchTerms': 'Controleer uw zoektermen of probeer het opnieuw.',

  // Search overlay
  'search.overlay.hint': 'Typ en druk op Enter of klik op Zoeken.',
  'search.overlay.placeholder': 'Zoeken (/) naar bronnen, docs en meer',
  'search.overlay.searchLabel': 'Zoeken',
  'search.overlay.noResults': 'Geen resultaten voor „{{query}}"',
  'search.overlay.tryDifferent': 'Andere zoektermen gebruiken of spelling controleren.',
  'search.overlay.topResults': 'Topresultaten',
  'search.overlay.documentation': 'Documentatie · ',

  // Location/Route toggle (Unternehmenssuche)
  'scout.unternehmenssuche.locationRadius': 'Plaats + straal',
  'scout.unternehmenssuche.routeCorridor': 'Route + corridor',
  'scout.unternehmenssuche.withoutLocation': 'Zonder locatie',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': 'Activiteitenheatmap (postcode-2)',
  'scout.preferences.defaultRegionLabel': 'Standaardregio',
  'scout.preferences.selectRegionPlaceholder': 'Regio selecteren',
  'scout.preferences.defaultStatusLabel': 'Standaardstatus',
  'scout.preferences.selectDefaultStatus': 'Standaardstatus selecteren',
  'scout.preferences.statusDraft': 'Concept',
  'scout.preferences.statusActive': 'Actief',
  'scout.preferences.statusCompleted': 'Afgerond',
  'scout.preferences.statusArchived': 'Gearchiveerd',
  'scout.preferences.saving': 'Wordt opgeslagen...',
  'scout.preferences.plzPrefixes': 'Postcodevoorvoegsels voor missies',
  'scout.preferences.plzPrefixesPlaceholder': 'Voer postcodevoorvoegsels komma gescheiden in (bijv. 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Max. routelengte (km)',
  'scout.preferences.maxRouteLengthDescription': 'Maximale routelengte in kilometers',
  'scout.preferences.autoGenerateMissions': 'Missies automatisch genereren (nachtelijke automatisering)',
  'scout.preferences.autoGenerateDescription': 'Indien ingeschakeld, worden missies automatisch gegenereerd op basis van uw instellingen.',
  'scout.preferences.defaultAssigneeLabel': 'Standaard verantwoordelijke',
  'scout.preferences.defaultAssigneePlaceholder': 'Standaard verantwoordelijke invoeren',
  'scout.preferences.defaultAssigneeAria': 'Standaard verantwoordelijke',
  'scout.preferences.defaultLeadCountLabel': 'Standaard aantal leads',
  'scout.preferences.defaultLeadCountAria': 'Standaard aantal leads',
  'scout.preferences.defaultDurationLabel': 'Standaardduur (dagen)',
  'scout.preferences.defaultDurationAria': 'Standaardduur in dagen',
  'scout.preferences.autoAssignLabel': 'Missies automatisch toewijzen aan standaard verantwoordelijke',
  'scout.preferences.productFamiliesLabel': 'Productfamilies',
  'scout.preferences.industryCodesLabel': 'Branches',
  'scout.preferences.keywordsLabel': 'Trefwoorden',
  'scout.preferences.keywordsPlaceholder': 'bijv. beton, estrich',
  'scout.preferences.minLeadsLabel': 'Min. leads per missie',
  'scout.preferences.minLeadsAria': 'Minimale leads per missie',
  'scout.preferences.maxLeadsLabel': 'Max. leads per missie',
  'scout.preferences.maxLeadsAria': 'Maximale leads per missie',
  'scout.preferences.dailyQuotaLabel': 'Aantal missies per dag',
  'scout.preferences.dailyQuotaAria': 'Maximale missies per dag',
  'scout.preferences.dailyQuotaHelper': 'Maximaal aantal automatisch gegenereerde missies per dag (1-3)',
  'scout.dailyPlanning.inField': 'In het veld',
  'scout.dailyPlanning.completed': 'Afgerond',
  'scout.dailyPlanning.openDay': 'Dag openen',
  'scout.dailyPlanning.dayMarkedCompleted': 'Deze dag is gemarkeerd als afgerond.',
  'scout.dailyPlanning.statusVisited': 'Bezocht',
  'scout.dailyPlanning.statusPlanned': 'Gepland',
  'scout.dailyPlanning.statusCompleted': 'Afgerond',
  'scout.createMission.title': 'Nieuwe missie aanmaken',
  'scout.createMission.description': 'Naam, filters en toewijzingen kiezen',
  'scout.createMission.nameLabel': 'Naam',
  'scout.createMission.nameRequired': 'Naam is verplicht',
  'scout.createMission.namePlaceholder': 'bijv. Stuttgart Noord — Koelinstallaties',
  'scout.createMission.nameAria': 'Missienaam',
  'scout.createMission.regionLabel': 'Regio (optioneel)',
  'scout.createMission.regionPlaceholder': 'bijv. postcode 70xxx',
  'scout.createMission.regionAria': 'Regio of postcode',
  'scout.createMission.ownerLabel': 'Eigenaar',
  'scout.createMission.ownerPlaceholder': 'E-mailadres',
  'scout.createMission.ownerAria': 'E-mailadres eigenaar',
  'scout.createMission.themeLabel': 'Thema (optioneel)',
  'scout.createMission.themePlaceholder': 'bijv. Koelinstallaties',
  'scout.createMission.themeAria': 'Missiethema',
  'scout.createMission.productLabel': 'Product (optioneel)',
  'scout.createMission.productPlaceholder': 'bijv. K-2000',
  'scout.createMission.productAria': 'Product',
  'scout.createMission.cancel': 'Annuleren',
  'scout.createMission.save': 'Opslaan',
  'scout.createMission.saveBusy': 'Opslaan…',
  'scout.createMission.cancelAria': 'Missie-aanmaak annuleren',
  'scout.createMission.saveAria': 'Missie opslaan',
  'scout.createMission.saveBusyAria': 'Missie wordt opgeslagen',

  // Inventory

  // Sales

  // Purchase


  // Settings
  'settings.description': 'Beheer uw applicatie-instellingen en aanpassingsopties',
  'settings.typography.title': 'Typografie',
  'settings.typography.description': 'Pas tekengrootte en dichtheid aan voor betere leesbaarheid of meer informatiedichtheid',
  'settings.typography.scale.title': 'Tekengrootte',
  'settings.typography.scale.description': 'Standaard komt overeen met Masterslight-basis; Comfort vergroot het lettertype voor lange sessies',
  'settings.typography.scale.ariaLabel': 'Tekengrootte-preset',
  'settings.typography.scale.compact': 'Compact',
  'settings.typography.scale.standard': 'Standaard',
  'settings.typography.scale.comfort': 'Comfort',
  'settings.tabs.appearance': 'Uiterlijk',
  'settings.tabs.account': 'Account',
  'settings.tabs.notifications': 'Meldingen',
  'settings.tabs.security': 'Beveiliging',
  'settings.language.title': 'Taalinstellingen',
  'settings.language.description': 'Kies uw voorkeurstaal voor de applicatie-interface',
  'settings.language.interfaceLanguage': 'Interfacetaal',
  'settings.language.interfaceLanguageDesc': 'Kies de taal voor menu\'s, knoppen en interface-elementen',
  'settings.theme.title': 'Kleurenschema',
  'settings.theme.description': 'Pas het uiterlijk en de kleuren van uw interface aan',
  'settings.theme.predefinedThemes': 'Wilt u uit 10 vooraf gedefinieerde thema\'s kiezen?',
  'settings.theme.goToThemeSettings': 'Naar thema-instellingen',
  'settings.themeSettings.title': 'Thema-instellingen',
  'settings.themeSettings.description': 'Pas het uiterlijk van uw applicatie aan met vooraf gedefinieerde thema\'s',
  'settings.themeSettings.themeDetails': 'Thema-details',
  'settings.themeSettings.themeId': 'Thema-ID:',
  'settings.themeSettings.colorScheme': 'Kleurenschema:',
  'settings.account.profile.title': 'Profielgegevens',
  'settings.account.profile.description': 'Werk uw persoonlijke gegevens en accountgegevens bij',
  'settings.account.profile.name': 'Naam',
  'settings.account.profile.email': 'E-mail',
  'settings.account.profile.role': 'Rol',
  'settings.account.profile.department': 'Afdeling',
  'settings.account.profile.editProfile': 'Profiel bewerken',
  'settings.account.data.title': 'Gegevensbeheer',
  'settings.account.data.description': 'Beheer uw gegevenssynchronisatie en back-upinstellingen',
  'settings.account.data.cloudSync': 'Cloudsynchronisatie',
  'settings.account.data.cloudSyncEnabled': 'Uw instellingen worden naar de cloud gesynchroniseerd',
  'settings.account.data.cloudSyncDisabled': 'Cloudsynchronisatie is uitgeschakeld (featureflag)',
  'settings.account.data.syncNow': 'Nu synchroniseren',
  'settings.notifications.title': 'Melding-instellingen',
  'settings.notifications.description': 'Configureer hoe u meldingen ontvangt',
  'settings.notifications.email.title': 'E-mailmeldingen',
  'settings.notifications.email.description': 'Meldingen per e-mail ontvangen',
  'settings.notifications.push.title': 'Pushmeldingen',
  'settings.notifications.push.description': 'Pushmeldingen in de browser ontvangen',
  'settings.notifications.system.title': 'Systeemwaarschuwingen',
  'settings.notifications.system.description': 'Belangrijke systeemmeldingen',
  'settings.notifications.configure': 'Configureren',
  'settings.security.title': 'Beveiligingsinstellingen',
  'settings.security.description': 'Beheer uw accountbeveiliging en privacy-instellingen',
  'settings.security.password.title': 'Wachtwoord',
  'settings.security.password.lastChanged': 'Laatst gewijzigd 30 dagen geleden',
  'settings.security.password.change': 'Wijzigen',
  'settings.security.twoFactor.title': 'Tweefactorauthenticatie',
  'settings.security.twoFactor.description': 'Voeg een extra beveiligingslaag toe',
  'settings.security.twoFactor.enable': 'Inschakelen',
  'settings.security.sessions.title': 'Sessiebeheer',
  'settings.security.sessions.description': 'Actieve sessies beheren',
  'settings.security.sessions.view': 'Sessies bekijken',
  'settings.company.title': 'Bedrijfsinstellingen',
  'settings.company.description': 'Beheer uw bedrijfsgegevens en instellingen',
  'settings.company.edit': 'Bedrijf bewerken',
  'settings.company.saveChanges': 'Wijzigingen opslaan',
  'settings.company.cancel': 'Annuleren',
  'settings.company.tabs.general': 'Algemeen',
  'settings.company.tabs.contact': 'Contact',
  'settings.company.tabs.billing': 'Facturering',
  'settings.company.tabs.branding': 'Merkenidentiteit',
  'settings.company.general.companyInfo': 'Bedrijfsgegevens',
  'settings.company.general.companyName': 'Bedrijfsnaam',
  'settings.company.general.legalName': 'Juridische naam',
  'settings.company.general.taxId': 'BTW-nummer',
  'settings.company.general.registrationNumber': 'Registratienummer',
  'settings.company.general.industry': 'Branch',
  'settings.company.general.foundedYear': 'Oprichtingsjaar',
  'settings.company.general.employees': 'Aantal medewerkers',
  'settings.company.general.industry.technology': 'Technologie',
  'settings.company.general.industry.manufacturing': 'Productie',
  'settings.company.general.industry.retail': 'Detailhandel',
  'settings.company.general.industry.healthcare': 'Gezondheidszorg',
  'settings.company.general.industry.finance': 'Financiën',
  'settings.company.general.industry.other': 'Overig',
  'settings.company.address.title': 'Adresgegevens',
  'settings.company.address.street': 'Straatadres',
  'settings.company.address.city': 'Stad',
  'settings.company.address.state': 'Provincie',
  'settings.company.address.zipCode': 'Postcode',
  'settings.company.address.country': 'Land',
  'settings.company.address.country.us': 'Verenigde Staten',
  'settings.company.address.country.ca': 'Canada',
  'settings.company.address.country.uk': 'Verenigd Koninkrijk',
  'settings.company.address.country.de': 'Duitsland',
  'settings.company.address.country.fr': 'Frankrijk',
  'settings.company.address.country.other': 'Overig',
  'settings.company.contact.title': 'Contactgegevens',
  'settings.company.contact.phone': 'Telefoonnummer',
  'settings.company.contact.email': 'E-mailadres',
  'settings.company.contact.website': 'Website',
  'settings.company.contact.supportEmail': 'Support-e-mail',
  'settings.company.billing.title': 'Factureringsinstellingen',
  'settings.company.billing.currency': 'Valuta',
  'settings.company.billing.taxRate': 'BTW-tarief (%)',
  'settings.company.billing.paymentTerms': 'Betalingsvoorwaarden',
  'settings.company.billing.billingCycle': 'Factureringscyclus',
  'settings.company.billing.paymentTerms.net15': 'Netto 15',
  'settings.company.billing.paymentTerms.net30': 'Netto 30',
  'settings.company.billing.paymentTerms.net45': 'Netto 45',
  'settings.company.billing.paymentTerms.net60': 'Netto 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Verschuldigd bij ontvangst',
  'settings.company.billing.cycle.monthly': 'Maandelijks',
  'settings.company.billing.cycle.quarterly': 'Per kwartaal',
  'settings.company.billing.cycle.annually': 'Jaarlijks',
  'settings.company.billing.cycle.custom': 'Aangepast',
  'settings.company.billing.summary.title': 'Factureringsoverzicht',
  'settings.company.billing.summary.currentPlan': 'Huidig abonnement',
  'settings.company.billing.summary.monthlyCost': 'Maandelijkse kosten',
  'settings.company.billing.summary.nextBillingDate': 'Volgende factuurdatum',
  'settings.company.billing.summary.paymentMethod': 'Betaalmethode',
  'settings.company.billing.summary.status': 'Status',
  'settings.company.billing.summary.active': 'Actief',
  'settings.company.branding.title': 'Merkenidentiteit & uiterlijk',
  'settings.company.branding.logo': 'Bedrijfslogo',
  'settings.company.branding.uploadLogo': 'Logo uploaden',
  'settings.company.branding.logoHint': 'PNG, JPG tot 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Favicon uploaden',
  'settings.company.branding.faviconHint': 'ICO, PNG tot 1MB',
  'settings.company.branding.primaryColor': 'Primaire kleur',
  'settings.company.branding.secondaryColor': 'Secundaire kleur',
  'settings.usersRoles.stats.totalUsers': 'Totaal gebruikers',
  'settings.usersRoles.stats.activeUsers': 'actieve gebruikers',
  'settings.usersRoles.stats.totalRoles': 'Totaal rollen',
  'settings.usersRoles.stats.roleConfigurations': 'Rolconfiguraties',
  'settings.userManagement.title': 'Gebruikersbeheer',
  'settings.userManagement.description': 'Beheer gebruikers, rollen en systeeminstellingen',
  'settings.userManagement.addUser': 'Gebruiker toevoegen',
  'settings.userManagement.editUser': 'Gebruiker bewerken',
  'settings.userManagement.createNewUser': 'Nieuwe gebruiker aanmaken',
  'settings.userManagement.updateUserInfo': 'Gebruikersgegevens bijwerken',
  'settings.userManagement.addNewUser': 'Een nieuwe gebruiker aan het systeem toevoegen',
  'settings.userManagement.tabs.users': 'Gebruikers',
  'settings.userManagement.tabs.appAccess': 'App-toegang',
  'settings.userManagement.tabs.roles': 'Rollen',
  'settings.userManagement.toast.userCreated': 'Gebruiker succesvol aangemaakt',
  'settings.userManagement.toast.userUpdated': 'Gebruiker succesvol bijgewerkt',
  'settings.userManagement.toast.userDeleted': 'Gebruiker succesvol verwijderd',
  'settings.userManagement.toast.roleCreated': 'Rol succesvol aangemaakt',
  'settings.userManagement.toast.roleUpdated': 'Rol succesvol bijgewerkt',
  'settings.userManagement.toast.roleDeleted': 'Rol succesvol verwijderd',
  'settings.userManagement.toast.error': 'Gebruiker kon niet worden aangemaakt',
  'settings.userManagement.toast.errorUpdate': 'Gebruiker kon niet worden bijgewerkt',
  'settings.userManagement.toast.errorDelete': 'Gebruiker kon niet worden verwijderd',
  'settings.userManagement.toast.errorRoleCreate': 'Rol kon niet worden aangemaakt',
  'settings.userManagement.toast.errorRoleUpdate': 'Rol kon niet worden bijgewerkt',
  'settings.userManagement.toast.errorRoleDelete': 'Rol kon niet worden verwijderd',
  'settings.integrations.settings.security.enabled': 'Ingeschakeld',
  'settings.integrations.settings.security.disabled': 'Uitgeschakeld',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'CRM-contacten',
  'crm.contacts.description': 'Klant- en leverancierscontacten met adresgegevens beheren',
  'crm.contacts.add': 'Contact toevoegen',
  'crm.contacts.edit': 'Contact bewerken',
  'crm.contacts.delete': 'Contact verwijderen',
  'crm.contacts.view360': '360° weergave',
  'crm.contacts.unassigned': 'Niet toegewezen',
  'crm.contacts.type.customer': 'Klant',
  'crm.contacts.type.supplier': 'Leverancier',
  'crm.contacts.type.partner': 'Partner',
  'crm.contacts.type.prospect': 'Prospect',
  'crm.contacts.status.active': 'Actief',
  'crm.contacts.status.inactive': 'Inactief',
  'crm.contacts.status.suspended': 'Geblokkeerd',
  'crm.contacts.validation.companyRequired': 'Bedrijfsnaam is verplicht',
  'crm.contacts.validation.streetRequired': 'Straatadres is verplicht',
  'crm.contacts.validation.postalRequired': 'Postcode is verplicht',
  'crm.contacts.validation.cityRequired': 'Stad is verplicht',
  'crm.contacts.validation.countryRequired': 'Land is verplicht',
  'crm.contacts.validation.nameRequired': 'Contactnaam is verplicht',
  'crm.contacts.validation.emailInvalid': 'Ongeldig e-mailadres',
  'crm.contacts.validation.phoneRequired': 'Telefoonnummer is verplicht',
  'crm.contacts.validation.salesPersonRequired': 'Verkoopmedewerker is verplicht',
  'crm.contacts.validation.ordererNameRequired': 'Bestellernaam is verplicht',
  'crm.contacts.validation.roleRequired': 'Rol is verplicht',
  'crm.contacts.validation.hoursRequired': 'Uren zijn verplicht',
  'crm.openMenu': 'Menu openen',

  // CRM - Leads
  'crm.leads.title': 'Leads',
  'crm.leads.description': 'Verkoopleads beheren en conversie volgen',
  'crm.leads.add': 'Lead toevoegen',
  'crm.leads.edit': 'Lead bewerken',
  'crm.leads.delete': 'Lead verwijderen',
  'crm.leads.status.new': 'Nieuw',
  'crm.leads.status.contacted': 'Gecontacteerd',
  'crm.leads.status.qualified': 'Gekwalificeerd',
  'crm.leads.status.proposal': 'Offerte',
  'crm.leads.status.negotiation': 'Onderhandeling',
  'crm.leads.status.closedWon': 'Gewonnen',
  'crm.leads.status.closedLost': 'Verloren',
  'crm.leads.source.website': 'Website',
  'crm.leads.source.referral': 'Verwijzing',
  'crm.leads.source.email': 'E-mail',
  'crm.leads.source.phone': 'Telefoon',
  'crm.leads.source.social': 'Sociale media',
  'crm.leads.source.other': 'Overig',
  'crm.leads.value': 'Waarde',
  'crm.leads.lastContact': 'Laatste contact',
  'crm.leads.notes': 'Notities',
  'crm.leads.search': 'Leads zoeken...',
  'crm.leads.filterByStatus': 'Filteren op status',
  'crm.leads.filterBySource': 'Filteren op bron',
  'crm.leads.totalLeads': 'Totaal leads',
  'crm.leads.pipelineValue': 'Pipelinewaarde',
  'crm.leads.qualifiedLeads': 'Gekwalificeerde leads',

  // Visit Report
  'visitReport.title': 'Bezoekrapport',
  'visitReport.createTitle': 'Bezoekrapport aanmaken',
  'visitReport.titleFor': 'Bezoekrapport voor {{name}}',
  'visitReport.visitType': 'Bezoekstype',
  'visitReport.coldVisit': 'Koud bezoek',
  'visitReport.appointment': 'Afspraak',
  'visitReport.salesOutcome': 'Verkoopresultaat',
  'visitReport.noContact': 'Geen contact',
  'visitReport.conversation': 'Gesprek',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Order',
  'visitReport.orderValue': 'Orderwaarde (EUR)',
  'visitReport.nextStep': 'Volgende stap',
  'visitReport.callback': 'Terugbellen',
  'visitReport.sendOffer': 'Offerte sturen',
  'visitReport.revisit': 'Herbezoek',
  'visitReport.completed': 'Afgerond',
  'visitReport.appointmentWindow': 'Afspraakvenster (optioneel)',
  'visitReport.from': 'Van',
  'visitReport.to': 'Tot',
  'visitReport.contactName': 'Naam gesprekspartner',
  'visitReport.enterName': 'Naam invoeren',
  'visitReport.roleFunction': 'Functie / rol',
  'visitReport.enterRole': 'Functie invoeren',
  'visitReport.isDecisionMaker': 'Is beslisser?',
  'visitReport.decisionMakerName': 'Naam beslisser',
  'visitReport.decisionMakerRole': 'Functie beslisser',
  'visitReport.email': 'E-mail (optioneel)',
  'visitReport.phone': 'Telefoon (optioneel)',
  'visitReport.notes': 'Notities (optioneel)',
  'visitReport.additionalInfo': 'Aanvullende informatie...',
  'visitReport.productsDiscussed': 'Producten besproken?',
  'visitReport.annualDemand': 'Jaarvraag',
  'visitReport.select': 'Selecteren',
  'visitReport.interest': 'Interesse',
  'visitReport.interestHigh': 'hoog',
  'visitReport.interestMedium': 'gemiddeld',
  'visitReport.interestLow': 'laag',
  'visitReport.modelFeedback': 'Was de systeemaanbeveling passend?',
  'visitReport.feedbackYes': 'Ja',
  'visitReport.feedbackPartially': 'Gedeeltelijk',
  'visitReport.feedbackNo': 'Nee',
  'visitReport.feedbackNotSeen': 'Niet gezien',
  'visitReport.branchCorrect': 'Branch correct? (optioneel)',
  'visitReport.selectBranch': 'Branch selecteren',
  'visitReport.branchConstruction': 'Bouw',
  'visitReport.branchIndustry': 'Industrie',
  'visitReport.branchTrade': 'Handel',
  'visitReport.branchService': 'Dienstverlening',
  'visitReport.noInterestReason': 'Reden geen interesse',
  'visitReport.wrongProduct': 'Verkeerd product',
  'visitReport.wrongTiming': 'Verkeerd moment',
  'visitReport.existingSupplier': 'Bestaande leverancier',
  'visitReport.noBudget': 'Geen budget',
  'visitReport.noNeed': 'Geen behoefte',
  'visitReport.decisionMakerNotReached': 'Beslisser niet bereikt',
  'visitReport.additionalRemarks': 'Overige opmerkingen (optioneel)',
  'visitReport.error': 'Fout',
  'visitReport.validationError': 'Selecteer bezoekstype en verkoopresultaat.',
  'visitReport.deferralNotPossible': 'Uitstel niet mogelijk',
  'visitReport.maxDeferralReached': 'U heeft het laatste rapport al uitgesteld. Vul dit in.',
  'visitReport.reportDeferred': 'Rapport uitgesteld',
  'visitReport.deferralMessage': 'U kunt het rapport later invullen.',
  'visitReport.reportCreated': 'Bezoekrapport aangemaakt',
  'visitReport.reportSaved': 'Bezoekrapport is opgeslagen.',
  'visitReport.reportSavedFor': 'Bezoekrapport voor {{name}} is opgeslagen.',
  'visitReport.reportError': 'Bezoekrapport kon niet worden aangemaakt.',
  'visitReport.stepOf': 'Stap {{current}} van {{total}}',
  'visitReport.back': 'Terug',
  'visitReport.cancel': 'Annuleren',
  'visitReport.inAHurry': 'Ik heb haast',
  'visitReport.next': 'Volgende',
  'visitReport.saving': 'Opslaan...',
  'visitReport.finishVisit': 'Bezoek afronden',
  'visitReport.contactNotes': 'Aanvullende informatie over gesprekspartner...',
  'visitReport.callingQueue.prompt': 'Moet een AI-afspraakgesprek voor deze lead worden voorbereid?',
  'visitReport.callingQueue.yes': 'Ja, in wachtrij plaatsen',
  'visitReport.callingQueue.no': 'Nee',
  'visitReport.callingQueue.toast': 'Lead in callingwachtrij geplaatst.',

  // --- SS-145: admin ---

  // --- SS-145: learning ---

  // --- SS-145: modals ---
  'modals.assignMissionModal.close': 'Sluiten',
  'modals.assignMissionModal.searchPlaceholder': 'Zoeken (titel/branch)',
  'modals.assignMissionModal.searchAriaLabel': 'Zoeken',
  'modals.missionQuickViewModal.description': 'Snelle overzicht van de missie. Open de missiepagina voor details.',
  'modals.missionQuickViewModal.close': 'Sluiten',
  'modals.missionQuickViewModal.openDetails': 'Details openen',
  'modals.missionQuickViewModal.openDetailsAria': 'Missiedetail openen',
  'modals.leadDetailModal.close': 'Sluiten',
  'modals.leadDetailModal.whoIsThis': 'Wie is dit?',
  'modals.leadDetailModal.whatDoTheyNeed': 'Wat hebben ze nodig?',
  'modals.leadDetailModal.whatDoISay': 'Wat zeg ik?',
  'modals.leadDetailModal.moreProducts': 'Meer producten',
  'modals.regionDetailsModal.description': 'Overzicht van missiedetails. Deze weergave is alleen-lezen.',
  'modals.regionDetailsModal.edit': 'Bewerken',
  'modals.regionDetailsModal.close': 'Sluiten',
  'modals.editRegionModal.close': 'Sluiten',
  'modals.editRegionModal.description': 'Tijd en notitie voor de missie bewerken. Status is alleen-lezen.',
  'modals.editRegionModal.statusReadonlySrOnly': 'Status is alleen-lezen.',
  'modals.splitAssignmentDialog.actionLabel': 'Actie selecteren',
  'modals.splitAssignmentDialog.confirmButton': 'Bevestigen',
  'modals.addAppointmentModal.companyAriaLabel': 'Bedrijf / lead selecteren of invoeren',
  'modals.addAppointmentModal.commitmentConfirmed': 'Bevestigd',
  'modals.rejectLead.title': 'Lead afwijzen',
  'modals.rejectLead.closeAria': 'Dialoog sluiten',
  'modals.rejectLead.description': 'Selecteer minimaal één afwijzingsreden.',
  'modals.rejectLead.reasonsLabel': 'Afwijzingsredenen',
  'modals.rejectLead.reasonsError': 'Selecteer minimaal één reden.',
  'modals.rejectLead.otherReasonLabel': 'Overige reden',
  'modals.rejectLead.otherReasonPlaceholder': 'Beschrijf de reden...',
  'modals.rejectLead.otherReasonAria': 'Overige afwijzingsreden',
  'modals.rejectLead.otherReasonError': 'Voer een reden in.',
  'modals.rejectLead.cancel': 'Annuleren',
  'modals.rejectLead.confirm': 'Afwijzen ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Niet meer actief',
  'modals.rejectLead.reason.temporarilyClosed': 'Tijdelijk gesloten',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Bekend en ongeschikt',
  'modals.rejectLead.reason.noInterest': 'Geen interesse',
  'modals.rejectLead.reason.wrongContact': 'Verkeerde contactpersoon',
  'modals.rejectLead.reason.other': 'Overig',

  // --- SS-145: ui-components + app-components ---
  'app.routes.loadingSettings': 'Instellingen laden...',
  'companySearch.filters.companySize': 'Bedrijfsgrootte',
  'curriculum.modules.pillar': 'Pijler',
  'curriculum.modules.selectLevel': 'Niveau selecteren',
  'curriculum.modules.selectPillar': 'Pijler selecteren',
  'curriculum.modules.selectPillarOption': 'Pijler selecteren',
  'learning.lessonViewer.audioNotSupported': 'Uw browser ondersteunt het audio-element niet.',
  'learning.lessonViewer.complete': 'Voltooien',
  'learning.lessonViewer.formatNotSupported': 'Formaat niet ondersteund',
  'learning.lessonViewer.videoNotSupported': 'Uw browser ondersteunt het video-element niet.',
  'learning.moduleEditor.pillar': 'Pijler',
  'learning.moduleEditor.pillarLabel': 'Pijler',
  'learning.tabs.availableLessons': 'Beschikbare lessen',
  'learning.tabs.availableQuizzes': 'Beschikbare quizzen',
  'missions.management.demoPerformed': 'Demo uitgevoerd',
  'missions.management.demoPerformedLabel': 'Demo uitgevoerd',
  'missions.management.kpiDescription': 'Beslisser bereikt, demo uitgevoerd, omzet',
  'missions.management.moreActions': 'Meer acties voor missie tonen',
  'missions.management.publish': 'Publiceren',
  'missions.management.searchPlaceholder': 'Zoeken (naam/regio/thema/product)',
  'mobile.layout.closeMenu': 'Menu sluiten',
  'mobile.layout.menu': 'Menu',
  'mobile.layout.noOfflineContent': 'Geen offline beschikbare content',
  'mobile.layout.offlinePerformance': 'Voor betere prestaties offline',
  'navigation.tileCard.openActions': 'Acties voor tegel openen',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Thüringen',
  'scout.sprints.ciEstimate': 'CI-runtime-schatting',
  'scout.sprints.estimatedMinutes': 'Geschatte minuten',
  'styleGuide.charts.noStatusColors': 'Grafieken mogen geen statuskleuren gebruiken',
  'styleGuide.confirmation': 'Bevestiging',
  'styleGuide.description': 'Beschrijving',
  'styleGuide.statusSemantics.success': 'Succes = Voltooid / OK',
  'tickets.list.filterPriority': 'Filteren op prioriteit',
  'ui.calendar.nextMonth': 'Volgende maand',
  'ui.errorBoundary.returnToDashboard': 'Terug naar dashboard',
  'ui.impersonation.selectImpersonation': 'Impersonatie selecteren',
  'ui.impersonation.selectUser': 'Gebruiker selecteren:',
  'ui.routingPreview.openAppleMaps': 'In Apple Maps openen',
  'ui.routingPreview.openGoogleMaps': 'In Google Maps openen',
  'ui.routingPreview.stopsLabel': '{{count}} stops · {{distance}} km · {{time}} min (geschat)',
  'ui.routingPreview.title': 'Routevoorvertoning',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Aanvullende notities',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Afspraak toevoegen',
  'scout.help.selectArticle': 'Selecteer links een artikel of gebruik de zoekfunctie om een helpartikel te openen.',

  // Visit Report — Rejection Sheet (B1)

  // Visit Report — Post-Visit Report (B2)

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.compliance.title': 'Openstaande bezoekrapporten',
  'scout.visitReport.compliance.description': 'U heeft {{count}} openstaande bezoekrapporten. Vul deze eerst in.',
  'scout.visitReport.compliance.lockoutTitle': 'Rapporten vereist',
  'scout.visitReport.compliance.lockoutDescription': 'Vul alle openstaande bezoekrapporten in voordat u verder kunt.',
  'scout.visitReport.compliance.deferButton': 'Later invullen',
  'scout.visitReport.compliance.deferCount': '{{remaining}} uitstellingen over',
  'scout.visitReport.compliance.noDeferrals': 'Geen uitstellingen meer beschikbaar',
  'scout.visitReport.compliance.fillReport': 'Rapport invullen',
  'scout.visitReport.compliance.morningLockout': 'Dagplanning geblokkeerd tot alle openstaande rapporten zijn ingevuld.',

  // Learning — Lehrplan & Curriculum (pages)
  'learning.lehrplan.title': 'Leerplan',
  'learning.lehrplan.subtitle': 'Leerplan en leerdoelen beheren',
  'learning.curriculumPlanning.title': 'Leerplanplanning',
  'learning.curriculumPlanning.subtitle': 'Leerplan structureren en leercontent toewijzen',

  // Navigation (App Overview, Tile View)
  'navigation.appOverview': 'App-overzicht',

  // PO Sprints (page titles)

  // Purchase (list/detail)

  // Sales (list)

  // Common (extra)
  'common.next': 'Volgende',

  // Warehouse Picking (action)

  // Scout Wochenplanung — Aggregates

  // Scout Mission Control — Plan View

  // CRM — Leads page (flat keys used in table/modal)
  'crm.leads': 'Leads',
  'crm.closedWon': 'Gewonnen deals',
  'crm.searchPlaceholder': 'Leads zoeken...',
  'crm.name': 'Naam',
  'crm.company': 'Bedrijf',
  'crm.contact': 'Contact',
  'crm.source': 'Bron',
  'crm.value': 'Waarde',
  'crm.lastContact': 'Laatste contact',
  'crm.viewDetails': 'Details bekijken',
  'crm.editLead': 'Lead bewerken',
  'crm.addNote': 'Notitie toevoegen',
  'crm.convertToCustomer': 'Naar klant converteren',
  'crm.deleteLead': 'Lead verwijderen',
  'crm.leadDetails': 'Lead-details',
  'crm.addNewLead': 'Nieuwe lead aanmaken',
  'crm.viewLeadDetails': 'Lead-details bekijken',
  'crm.createNewLead': 'Nieuwe lead aanmaken',
  'crm.fullName': 'Volledige naam',
  'crm.email': 'E-mail',
  'crm.phone': 'Telefoon',
  'crm.estimatedValue': 'Geschatte waarde',
  'crm.notes': 'Notities',
  'crm.status.new': 'Nieuw',
  'crm.status.contacted': 'Gecontacteerd',
  'crm.status.qualified': 'Gekwalificeerd',
  'crm.status.proposal': 'Offerte',
  'crm.status.negotiation': 'Onderhandeling',
  'crm.status.closedWon': 'Gewonnen',
  'crm.status.closedLost': 'Verloren',
  'crm.source.website': 'Website',
  'crm.source.referral': 'Verwijzing',
  'crm.source.tradeShow': 'Beurs',
  'crm.source.coldCall': 'Koude acquisitie',
  'crm.source.socialMedia': 'Sociale media',
  'crm.source.emailCampaign': 'E-mailcampagne',

  // Supplier onboarding — Form (CompanyInfoSection, ContactInfoSection, DocumentUploadSection)

  // Placeholders (supplier forms)

  // Form (supplier — ContactInfoSection)

  // Role (supplier contact)

  // Country (supplier address)
  'country.US': 'Verenigde Staten',
  'country.CA': 'Canada',
  'country.MX': 'Mexico',
  'country.GB': 'Verenigd Koninkrijk',
  'country.DE': 'Duitsland',
  'country.FR': 'Frankrijk',
  'country.other': 'Overig',

  // Business type (supplier — CompanyInfoSection uses businessType.*)

  // Missing keys (added from en/de)
  'common.saving': 'Opslaan…',
  'common.archive': 'Archief',
  'scout.missions.industries.placeholder': 'Branches selecteren',
  'scout.missions.industries.search': 'Branches zoeken...',
  'scout.missions.industries.empty': 'Geen branches gevonden',
  'scout.missions.products.placeholder': 'Productfamilies selecteren',
  'scout.missions.products.search': 'Productfamilies zoeken...',
  'scout.missions.products.empty': 'Geen productfamilies gevonden',
  'scout.search.selectStatus': 'Status selecteren...',
  'scout.dailyPlanning.jokerAdd': 'Joker gebruiken',
  'scout.dailyPlanning.jokerTitle': 'Jokerstop',
  'scout.dailyPlanning.jokerUsed': 'gebruikt',
  'scout.dailyPlanning.jokerLimitReached': 'Dagelijkse limiet jokerstops bereikt.',
  'scout.dailyPlanning.jokerCompany': 'Bedrijf',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Bedrijfsnaam invoeren',
  'scout.dailyPlanning.jokerReason': 'Reden',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'Waarom is deze stop nodig?',
  'scout.dailyPlanning.jokerCancel': 'Annuleren',
  'scout.dailyPlanning.jokerSubmit': 'Joker gebruiken',
  'scout.dailyPlanning.jokerCreateError': 'Jokerstop kon niet worden aangemaakt.',
  'missions.management.decisionMakerMet': 'Beslisser gesproken',
  'missions.management.wonAmount': 'Gewonnen bedrag',
  'common.active': 'Actief',
  'common.archived': 'Gearchiveerd',
  'common.planned': 'Gepland',
  'missionControl.totalLeads': 'Totaal aantal leads',
  'missionControl.completedLeads': 'Voltooide leads',

  'survey.contact.name': 'Naam',
  'survey.contact.namePlaceholder': 'Naam invoeren',
  'survey.contact.function': 'Functie / Rol',
  'survey.contact.functionPlaceholder': 'Functie invoeren',
  'survey.contact.email': 'E-mail',
  'survey.contact.emailPlaceholder': 'E-mailadres invoeren',
  'survey.contact.phone': 'Telefoon',
  'survey.contact.phonePlaceholder': 'Telefoonnummer invoeren',
  'survey.contact.isDecisionMaker': 'Is beslisser?',
};
